import{j as e}from"./chunk-GEPA7FLG.js";e();import{gql as r}from"@apollo/client";var i=r`
  query adminNftStakingGroups($address: String!) {
    adminNftStakingGroups(address: $address) {
      farmingToken {
        collection
        name
        ticker
        assets {
          svgUrl
          pngUrl
        }
      }
      rewardToken {
        identifier
        decimals
        name
        ticker
        assets {
          svgUrl
          pngUrl
        }
      }
      creationDate
      expiryDate
      totalStaked
      groupId
      farms {
        areRewardsLocked
        totalStaked
        endsDate
        unbound
        farmState
        farmAddress
        dailyReward
        isFixedReward
        rewardsLeft
      }
    }
  }
`;export{i as a};
//# sourceMappingURL=chunk-SFLOSJJY.js.map
